import React, { ReactNode } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { useAsyncState } from '@/utils/hooks';
import { getUserDetails } from '@/services/users';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { Tabs } from '@ygtechnologies/rubus-ui';
import { BygrUserDetails } from '@/types';
import { UserDashboard } from './UserDashboard';
import { UserProjects } from './UserProjects';
import { UserProfiles } from './UserProfiles';
import { UserUnits } from './UserUnits';

export type UserDetailsTab = 'dashboard' | 'profiles' | 'projects' | 'units';
interface TabSettings {
    id: UserDetailsTab;
    name: string;
    render(opts: { user: BygrUserDetails; reload(): void }): ReactNode;
}

const tabs: TabSettings[] = [
    {
        id: 'dashboard',
        name: 'Dashboard',
        render: ({ user, reload }) => <UserDashboard user={user} reload={reload} />,
    },
    {
        id: 'profiles',
        name: 'Profiles',
        render: ({ user, reload }) => <UserProfiles user={user} reload={reload} />,
    },
    {
        id: 'projects',
        name: 'Projects',
        render: ({ user, reload }) => <UserProjects user={user} reload={reload} />,
    },
    {
        id: 'units',
        name: 'Units',
        render: ({ user, reload }) => <UserUnits user={user} reload={reload} />,
    },
];

export interface UserDetailsProps {}

export const UserDetails: React.FC<UserDetailsProps> = () => {
    const { userId, tab } = useParams<{ userId: string; tab: UserDetailsTab }>();
    const [user, , reload] = useAsyncState(() => getUserDetails(+userId), [userId], null);

    if (!user) {
        return <LoadingIndicator />;
    }

    const activeTab = tabs.find((x) => x.id === tab);

    return (
        <div>
            <h2>User {user?.displayName ?? user?.email}</h2>
            <Tabs.Container activeId={tab} variant="underline">
                {tabs.map((t) => (
                    <Tabs.Tab key={t.id} id={t.id} as={Link} to={`/users/${user.id}/${t.id}`} label={t.name} />
                ))}
                <Tabs.Content>
                    <div className="tab-panel">{activeTab?.render({ user: user, reload: reload })}</div>
                </Tabs.Content>
            </Tabs.Container>
        </div>
    );
};
